// extracted by mini-css-extract-plugin
module.exports = {"notification":"YU119","inner":"Zd0MB","icon":"kLyp7","error":"cs7dD","warning":"V7xZ-","success":"uaXnw","close":"_1BzX0","content":"aZKr+","title":"ONuYF","text":"dfnG3"};